import React from 'react';
import { getInsuranceForecastSummary, getPracticeInsuranceForecastSummary } from 'api/financials';
import { TInsuranceForecastSummary } from 'types/financials';

const globalData: Partial<Record<'my' | 'practice', TInsuranceForecastSummary>> = {};

const useInsuranceForecastSummary = (
    timeRangeMonths?: number,
    isPractice = false,
): [TInsuranceForecastSummary | undefined, boolean, () => void] => {
    const scope = isPractice ? 'practice' : 'my';
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<TInsuranceForecastSummary | undefined>(globalData[scope]);
    const fetchData = async () => {
        try {
            setLoading(true);
            const request = isPractice ? getPracticeInsuranceForecastSummary : getInsuranceForecastSummary;
            const result = await request(timeRangeMonths || 0);
            if (!result.error) {
                const data: TInsuranceForecastSummary = result?.data?.data;
                globalData[scope] = data;
                setItems(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (timeRangeMonths !== undefined) {
            fetchData();
        }
    }, [timeRangeMonths, isPractice]);

    return [items, loading, fetchData];
};

export default useInsuranceForecastSummary;
